import Vue from 'vue'

if (!Vue.__helpers_mixin__) {
    Vue.__helpers_mixin__ = true
    Vue.mixin({
        methods: {
            scrollTo (el) {
                const header = document.getElementById('navbar')
                const targetElement = document.getElementById(el)

                if (targetElement) {
                    const headerHeight = header ? header.offsetHeight : 0

                    window.scrollTo({
                        top: targetElement.offsetTop - headerHeight,
                        behavior: 'smooth'
                    })
                }
            }
        }
    })
}
